webpackJsonp([37],{

/***/ "LY8C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__("rplX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scss_mixin_reset_scss__ = __webpack_require__("bl/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scss_mixin_reset_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scss_mixin_reset_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tools_polyfill__ = __webpack_require__("c5r8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tools_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_tools_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_loadable__ = __webpack_require__("wF3A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_commons_PageLoading__ = __webpack_require__("OMeG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LoadPassportJs__ = __webpack_require__("NUi6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_commons_ScrollToTop__ = __webpack_require__("7l3g");
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){try{if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;}catch(_e4){try{_e4.message+=''+'';window.JSTracker.catch(_e4);}catch(e){}throw _e4;}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import base&&tool
// reset 样式
// scrollToTop 路由切换时候页面默认滚动到顶部，可在此控件中配置白名单
// import containers
// import processOnterHook from './router/RouterRenderBeforeHandle';
// 异步加载文件 参考文档 https://webpack.js.org/guides/code-splitting/#dynamic-imports
// 参数中的注释部分不建议删除，原因请看上述文档
// const Login = Loadable({
//     loader: () => import('./containers/Login/Login' /* webpackChunkName:"Login" */),
//     loading: PageLoading,
// });
var Superiority=__WEBPACK_IMPORTED_MODULE_6_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "SaS/"));},loading:__WEBPACK_IMPORTED_MODULE_7_commons_PageLoading__["a" /* default */]});// 主页面路由
var MainRouterPack=function(_React$PureComponent){_inherits(MainRouterPack,_React$PureComponent);function MainRouterPack(){_classCallCheck(this,MainRouterPack);return _possibleConstructorReturn(this,(MainRouterPack.__proto__||Object.getPrototypeOf(MainRouterPack)).apply(this,arguments));}_createClass(MainRouterPack,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'lm-ui-content clearfix'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_commons_ScrollToTop__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Switch"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Route"],{path:'/superiority',component:Superiority}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["Redirect"],{to:'/superiority'}))));}}]);return MainRouterPack;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);var MainRouter=Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["withRouter"])(MainRouterPack);var rootRender=function rootRender(){try{var _rootElement=document.getElementById('root');__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["HashRouter"],null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(MainRouter,null)),_rootElement);}catch(_e6){try{_e6.message+=''+':62';window.JSTracker.catch(_e6);}catch(e){}throw _e6;}};// 进入页面之前先请求导流接口，看需要往哪跳转
// 0（成功），1（失败），2（未登录），3（未实名）
Object(__WEBPACK_IMPORTED_MODULE_8__components_LoadPassportJs__["a" /* default */])(function(){rootRender();});

/***/ }),

/***/ "NUi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mobileLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_api_Helper__ = __webpack_require__("2ZK4");
var mobileLogin={getCode:function getCode(){},freshValidateCode:function freshValidateCode(){},loginCommit:function loginCommit(){}};var loadPassportjs=function loadPassportjs(call){try{var _WBAPP=window.WBAPP?window.WBAPP:{};console.log(_WBAPP);if(Object(__WEBPACK_IMPORTED_MODULE_0_api_Helper__["h" /* is58App */])()&&_WBAPP.util.compareVersion(_WBAPP.common.appVersion,'8.3')>=0){call();mobileLogin.getCode=function(_ref){var mobile=_ref.mobile,callback=_ref.callback;_WBAPP.invoke('get_verification_code',{tel:mobile},function(data){var res=JSON.parse(data);if(res.state==='0'){// 防止用户刷新或者关闭页面，这里存储起来，登录后清除
localStorage.setItem('get_verification_code_token',res.token);callback({code:0});}else{callback({code:1,msg:'获取码验证失败!'});}});};mobileLogin.loginCommit=function(_ref2){var mobile=_ref2.mobile,mobilecode=_ref2.mobilecode,callback=_ref2.callback;console.log('触发');_WBAPP.invoke('login_use_code',{tel:mobile,// 电话号码
verification:mobilecode,// 验证码
token:localStorage.getItem('get_verification_code_token')// get_verification_code 传过来的token值
},function(data){if(data==='0'){localStorage.removeItem('get_verification_code_token');callback({code:0});}else{callback({code:1,msg:'登录失败!'});}});};}else{var passportjs=document.createElement('script');passportjs.type='text/javascript';passportjs.src=(document.location.protocol==='https:'?' https://':' http://')+'j1.58cdn.com.cn/js/login/passportMobileLogin.js';passportjs.onload=function(){try{call();var _mobileLogin2=new window.MobileLogin({source:'58-haojie-m',path:window.location.href});mobileLogin.getCode=_mobileLogin2.getCode.bind(_mobileLogin2);mobileLogin.freshValidateCode=_mobileLogin2.freshValidateCode.bind(_mobileLogin2);mobileLogin.loginCommit=_mobileLogin2.loginCommit.bind(_mobileLogin2);}catch(_e2){try{_e2.message+=''+':56';window.JSTracker.catch(_e2);}catch(e){}throw _e2;}};var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(passportjs,s);}}catch(_e){try{_e.message+=''+':8';window.JSTracker.catch(_e);}catch(e){}throw _e;}};/* harmony default export */ __webpack_exports__["a"] = (loadPassportjs);

/***/ }),

/***/ "OMeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss__ = __webpack_require__("fNj4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_scss__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){try{if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;}catch(_e4){try{_e4.message+=''+'';window.JSTracker.catch(_e4);}catch(e){}throw _e4;}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * 为react-loadable准备的loading组件
 */var PageLoading=function(_React$PureComponent){_inherits(PageLoading,_React$PureComponent);function PageLoading(){_classCallCheck(this,PageLoading);return _possibleConstructorReturn(this,(PageLoading.__proto__||Object.getPrototypeOf(PageLoading)).apply(this,arguments));}_createClass(PageLoading,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'init-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'icon-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 -2 59.75 60.25',width:'100%',height:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'#ccc',d:'M29.69-.527C14.044-.527 1.36 12.158 1.36 27.806S14.043 56.14 29.69 56.14c15.65 0 28.334-12.686 28.334-28.334S45.34-.527 29.69-.527zm.185 53.75c-14.037 0-25.417-11.38-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.38 25.417 25.417-11.38 25.416-25.417 25.416z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{fill:'none',stroke:'#108ee9',strokeWidth:'3',strokeLinecap:'round',strokeMiterlimit:'10',d:'M56.587 29.766c.37-7.438-1.658-14.7-6.393-19.552'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u6B63\u5728\u52A0\u8F7D')));}}]);return PageLoading;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (PageLoading);

/***/ }),

/***/ "bl/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNj4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wF3A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("GiK3");
var PropTypes = __webpack_require__("KSGD");

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ })

},["LY8C"]);


// WEBPACK FOOTER //
// static/js/ground.08c223aa.js